import { postClassTime, getClassTimeList, updateClassTime, deleteClassTime } from "@/services/class-day-and-time.service";
import { formatDateToHour } from "@/utils/utils";

// initial state
const state = () => ({
  classTimeModel: {},

  classTimeList: [],
});

// mutations
const mutations = {
  setClassTimeModel(state, data) {
    state.classTimeModel = data;
  },

  setClassTimeList(state, data) {
    state.classTimeList = data;
  },
};

// actions
const actions = {
  //Sınıf Gün ve Saat Listesi
  async loadClassTimeList(vuexContext, classObj) {
    return await getClassTimeList(classObj).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
        item.label = `${formatDateToHour(item.startDate)} - ${formatDateToHour(item.endDate)}`;
      });
      vuexContext.commit("setClassTimeList", data);
      return data;
    });
  },

  async postClassTime(vuexContext, data) {
    return await postClassTime(data);
  },

  async updateClassTime(vuexContext) {
    return await updateClassTime(vuexContext.state.classTimeModel);
  },

  async deleteClassTime(vuexContext) {
    return await deleteClassTime(vuexContext.state.classTimeModel.id);
  },

  addClassTimeList(vuexContext, data) {
    vuexContext.commit("setClassTimeList", data);
  },

  addClassTimeModel(vuexContext, data) {
    vuexContext.commit("setClassTimeModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
